module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "light": ""
    }
  }, [_c('v-toolbar', {
    staticStyle: {
      "position": "fixed"
    },
    attrs: {
      "dense": ""
    }
  }, [_c('v-btn', {
    class: {
      grey: _vm.materieelSelected
    },
    attrs: {
      "disabled": !_vm.validlogin
    },
    nativeOn: {
      "click": function($event) {
        return _vm.materieelClicked($event)
      }
    }
  }, [_vm._v("Materieel")]), _vm._v(" "), _c('v-btn', {
    class: {
      grey: _vm.wervenSelected
    },
    attrs: {
      "disabled": !_vm.validlogin
    },
    nativeOn: {
      "click": function($event) {
        return _vm.wervenClicked($event)
      }
    }
  }, [_vm._v("Werven")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    class: {
      grey: _vm.accountSelected
    },
    nativeOn: {
      "click": function($event) {
        return _vm.accountClicked($event)
      }
    }
  }, [_vm._v("Account")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "padding-top": "48px"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.materieelSelected),
      expression: "materieelSelected"
    }]
  }, [_c('materieel')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wervenSelected),
      expression: "wervenSelected"
    }]
  }, [_c('werven')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.handleidingenSelected),
      expression: "handleidingenSelected"
    }]
  }, [_c('handleidingen')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.accountSelected),
      expression: "accountSelected"
    }]
  }, [(_vm.validlogin) ? _c('div', {
    staticClass: "text-xs-center elevation-12",
    staticStyle: {
      "width": "60%",
      "min-width": "400px",
      "margin-left": "auto",
      "margin-right": "auto",
      "margin-top": "20px",
      "margin-bottom": "20px",
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "text-lg-center",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("WELKOM, " + _vm._s(_vm.user.username))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-center",
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.uitloggenClicked($event)
      }
    }
  }, [_vm._v("AFMELDEN")]), _vm._v(" "), (_vm.user_admin) ? _c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-lg-left",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("GEBRUIKERS:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('grid', {
    attrs: {
      "data": _vm.UsersData,
      "columns": _vm.UsersColumns
    },
    on: {
      "GridRowClicked": _vm.GridRowClicked
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.UserGeselecteerd),
      expression: "UserGeselecteerd"
    }],
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Gebruikersnaam"
    },
    model: {
      value: (_vm.UserUsername),
      callback: function($$v) {
        _vm.UserUsername = $$v
      },
      expression: "UserUsername"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Voornaam"
    },
    model: {
      value: (_vm.UserVoornaam),
      callback: function($$v) {
        _vm.UserVoornaam = $$v
      },
      expression: "UserVoornaam"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Naam"
    },
    model: {
      value: (_vm.UserNaam),
      callback: function($$v) {
        _vm.UserNaam = $$v
      },
      expression: "UserNaam"
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-btn', {
    staticClass: "green",
    nativeOn: {
      "click": function($event) {
        return _vm.UserOpslaanClicked($event)
      }
    }
  }, [_vm._v("Opslaan")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-btn', {
    staticClass: "red",
    nativeOn: {
      "click": function($event) {
        return _vm.UserVerwijderenClicked($event)
      }
    }
  }, [_vm._v("Verwijderen")])], 1)], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Nieuw Wachtwoord",
      "append-icon": _vm.e2 ? 'visibility' : 'visibility_off',
      "type": _vm.e2 ? 'password' : 'text'
    },
    on: {
      "click:append": function () { return (_vm.e2 = !_vm.e2); }
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.kp($event)
      }
    },
    model: {
      value: (_vm.UserWW),
      callback: function($$v) {
        _vm.UserWW = $$v
      },
      expression: "UserWW"
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-btn', {
    staticClass: "green",
    nativeOn: {
      "click": function($event) {
        return _vm.UserWWWijzigen($event)
      }
    }
  }, [_vm._v("Wachtwoord Wijzigen")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  })], 1)], 1)], 1)], 1)]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.validlogin) ? _c('div', {
    staticClass: "text-xs-center elevation-12",
    staticStyle: {
      "width": "60%",
      "min-width": "400px",
      "margin-left": "auto",
      "margin-right": "auto",
      "margin-top": "20px",
      "margin-bottom": "20px",
      "padding": "10px"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Gebruikersnaam"
    },
    model: {
      value: (_vm.gebruikersnaam),
      callback: function($$v) {
        _vm.gebruikersnaam = $$v
      },
      expression: "gebruikersnaam"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Wachtwoord",
      "append-icon": _vm.e1 ? 'visibility' : 'visibility_off',
      "type": _vm.e1 ? 'password' : 'text'
    },
    on: {
      "click:append": function () { return (_vm.e1 = !_vm.e1); }
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.kp($event)
      }
    },
    model: {
      value: (_vm.wachtwoord),
      callback: function($$v) {
        _vm.wachtwoord = $$v
      },
      expression: "wachtwoord"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showError),
      expression: "showError"
    }],
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.errormsg))]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-center",
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.inloggenClicked($event)
      }
    }
  }, [_vm._v("AANMELDEN")])], 1) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-007da540"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 41
// module chunks = 3